import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

const URL = API_URL + "/organization/member/invite";
const VERSION = 0;

/**
 * @remarks 
 * 
Success Case:
  
  If the invitations are sent successfully, the response will include:
    - success: true
    - An invitations array containing objects with:
           email: The email address of the invited member.
           invitationLink: A link for the invited member to join the organization.

Failure Case:

  If there are issues sending the invitations, the response will include:
    - success: false
    - An invitations array containing objects with:
           email: The email address of the member.
           issue: A string describing the issue, or null if there is no problem with the email.
 
 * @example
    ## Success       
       
      {
        "success": true,
         "invitations": [
        {
            "email": "john.doe@example.com",
            "invitationLink": "https://example.com/invite/john.doe"
        },
        {
            "email": "jane.smith@example.com",
            "invitationLink": "https://example.com/invite/jane.smith"
        }
        ]
      }

    ## Failure
     
      {
        "success": false,
        "invitations": [
        {
            "email": "john.doe@e",
            "issue": "Invalid email address"
        },
        {
            "email": "jane.smith@example.com",
            "issue": null
        }
    ]
}
           */

export type InviteMembersResponse =
    | {
          success: false;
          invitations: {
              email: string;
              issue: string | null;
          }[];
      }
    | {
          success: true;
          invitations: {
              email: string;
              invitationLink: string;
          }[];
      };

export default async function inviteMembersToOrganization(emails: string[]): Promise<InviteMembersResponse> {
    const options: httpNetworking.POSTRequestConfig = {
        timeout: 50000
    };
    const params = {
        emails
    };

    const response = (await httpNetworking.simplePOSTRequest(URL, params, options, VERSION)).data;
    return response;
}
